<template>
  <div class="mt-12"
       :class="{ 'bg-yellow-100 p-8 shadow-lg': block.options.content_type == 'info' }">

    <h1 v-if="block.options.title_format == 'H1'" v-html="block.title"></h1>
    <h1 v-if="block.options.title_format == ''" v-html="block.title"></h1>
    <h2 v-if="block.options.title_format == 'H2'" v-html="block.title"></h2>
    <h3 v-if="block.options.title_format == 'H3'" v-html="block.title"></h3>

    <div v-html="block.content"></div>

    <pre v-if="debug">
      {{ block }}
    </pre>
  </div>
</template>

<script>
export default {
  props: [ 'block' ],
  data() {
    return {
      debug: false
    }
  }
}
</script>